export default {
  namespaced: true,
  state: {
    items: {}
  },
  getters: {
    items: state => state.items
  },
  mutations: {},
  actions: {
    createStory: ({ dispatch }, item) => dispatch('createItem', { resource: 'stories', item }, { root: true }),
    fetchStory: ({ dispatch }, id) => dispatch('fetchItem', { resource: 'stories', id }, { root: true }),
    fetchStories: ({ dispatch }, { ids }) => dispatch('fetchItems', { resource: 'stories', ids }, { root: true }),
    findStory: ({ dispatch }, query) => dispatch('findItem', { resource: 'stories', query }, { root: true }),
    findStories: ({ dispatch }, { query, order, limit }) => dispatch('findItems', {
      resource: 'stories',
      query,
      order,
      limit
    }, { root: true }),
    updateStory: ({ dispatch }, { id, data }) => dispatch('updateItem', { resource: 'stories', id, data }, { root: true }),
  }
};
